import React, { useEffect, useRef, useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Select from "react-select";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Utils from "../../common/athleteCommon/Utils";
import * as api from "../../common/athleteCommon/API";

interface Props {
    history: any;
}

const SurgeryHistory: React.FC<Props> = ({ history }) => {

    const surgeryCatgList = [{ surgCatgId: "1", surgCatgName: "Orthopedic" }, { surgCatgId: "2", surgCatgName: "Cardiovascular" }, { surgCatgId: "3", surgCatgName: "Neurological" }, { surgCatgId: "4", surgCatgName: "General surgery" }, { surgCatgId: "5", surgCatgName: "Other" }]
    const bdyRgnList = [{ bdyRgnId: "1", bdyRgnName: "Head" }, { bdyRgnId: "2", bdyRgnName: "Face" }, { bdyRgnId: "3", bdyRgnName: "Cervical spine/neck" }, { bdyRgnId: "4", bdyRgnName: "Shoulder" }, { bdyRgnId: "5", bdyRgnName: "Upper Arm" }, { bdyRgnId: "6", bdyRgnName: "Elbow" },
    { bdyRgnId: "7", bdyRgnName: "Forearm" }, { bdyRgnId: "8", bdyRgnName: "Wrist" }, { bdyRgnId: "9", bdyRgnName: "Hand/Fingers" }, { bdyRgnId: "10", bdyRgnName: "Thoracic spine" }, { bdyRgnId: "11", bdyRgnName: "Lumbar spine" }, { bdyRgnId: "12", bdyRgnName: "Pelvis" }, { bdyRgnId: "13", bdyRgnName: "Hip" },
    { bdyRgnId: "14", bdyRgnName: "Thigh" }, { bdyRgnId: "15", bdyRgnName: "Knee" }, { bdyRgnId: "16", bdyRgnName: "Lower Leg" }, { bdyRgnId: "17", bdyRgnName: "Ankle" }, { bdyRgnId: "18", bdyRgnName: "Foot/toes" }]
    const rehabList = [{ rehabId: "1", rehabName: "1-6 days" }, { rehabId: "2", rehabName: "1-3 weeks" }, { rehabId: "3", rehabName: "3-6 weeks" }, { rehabId: "4", rehabName: "More than 6 weeks" }]

    const [surgeryHistory, setSurgeryHistory] = useState<any[]>([])
    const [dos, setDos] = useState("");
    const [ctgry, setCtgry] = useState("");
    const [bdyRgn, setBdyRgn] = useState("");
    const [pcdrSumry, setPcdrSumry] = useState("");
    const [comp, setComp] = useState("");
    const [rehab, setRehab] = useState("");
    const [athleteId, setAthleteId] = useState("");
    const [surgId, setSurgId] = useState("");
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const formRef = useRef(null);

    useEffect(() => {
        setSurgeryHistory(history || [])
    }, [history])

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    function editDetails(details) {
        setIsEdit(true)
        setDos(details.dateOfSurgery)
        setBdyRgn(details.bodyRegion)
        setCtgry(details.category)
        setComp(details.complicationsIfAny)
        setPcdrSumry(details.procedureSummary)
        setRehab(details.rehabilitationDuration)
        setAthleteId(details.athleteId)
        setSurgId(details.surgeryProfileId)
        setOpenModal(true)
    }

    function addRecord() {
        setIsEdit(false)
        setDos("")
        setBdyRgn("")
        setCtgry("")
        setComp("")
        setPcdrSumry("")
        setRehab("")
        setAthleteId("")
        setSurgId("")
        setOpenModal(true)
    }


    function handleSubmit() {
        // e.preventDefault();
        // if (!formRef.current.checkValidity()) {
        //     // Manually trigger native HTML5 validation message
        //     formRef.current.reportValidity();
        // } else {
        if (isEdit) {
            updateDetails();
        } else {
            const formData = new FormData();
            formData.append("dateOfSurgery", dos);
            formData.append("category", ctgry);
            formData.append("bodyRegion", bdyRgn);
            formData.append("procedureSummary", pcdrSumry);
            formData.append("complicationsIfAny", comp);
            formData.append("rehabilitationDuration", rehab);
            const srgryHstry = api.AddSurgeryDetails;
            fetch(srgryHstry, {
                method: "POST",
                headers: {
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                },
                body: formData
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.error == false) {
                        Swal.fire({
                            title: 'Success',
                            text: result.message,
                            icon: 'success',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        })
                            .then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                    // navigate(routes.manipurlogin)
                                }
                            });
                    } else {
                        if (result.code == 401) {
                            Utils.logoutUser();
                        }
                        Swal.fire({
                            title: 'Error',
                            text: result.message,
                            icon: 'error',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        })
                    }
                })
        }
        // }
    }

    function updateDetails() {
        const formData = new FormData();
        formData.append("dateOfSurgery", dos);
        formData.append("category", ctgry);
        formData.append("bodyRegion", bdyRgn);
        formData.append("procedureSummary", pcdrSumry);
        formData.append("complicationsIfAny", comp);
        formData.append("rehabilitationDuration", rehab);
        const srgryHstry = api.EditSurgeryDetails + "/" + surgId;
        fetch(srgryHstry, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                        .then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                                // navigate(routes.manipurlogin)
                            }
                        });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    return (
        <>
            <div className="card-tableset" style={{ padding: "10px" }}>
                <div className="card-body" >
                    <div className="row align-items-center" >
                        <div className="d-flex justify-content-end">
                            <Link className="btn" to="#" onClick={addRecord}>
                                <i className="feather-plus" />
                            </Link>
                        </div>
                        {/* {surgeryHistory.length > 0 && (
                            <div className="table-responsive mt-4"> */}
                        {/* <table className="table table-bordered">
                                    <thead className="table-light">
                                        <tr>
                                            {Object.keys(surgeryHistory[0]).map((key) => (
                                                <th key={key} className="text-uppercase text-center">
                                                    {key}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {surgeryHistory.map((row: any, index: number) => (
                                            <tr key={index}>
                                                {Object.values(row).map((value: any, i: number) => (
                                                    <td key={i} className="text-center">
                                                        {value}
                                                    </td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table> */}
                        {/* </div>
                        )} */}

                        <div className="table-responsive table-datatble">
                            <table className="table datatable">
                                <thead className="thead-light">
                                    <tr>
                                        <th className="text-uppercase text-center">Sl No</th>
                                        <th className="text-uppercase text-center">Category</th>
                                        <th className="text-uppercase text-center">Body Region</th>
                                        <th className="text-uppercase text-center">Date of surgery</th>
                                        <th className="text-uppercase text-center">Procedure Summary</th>
                                        <th className="text-uppercase text-center">Complications if any</th>
                                        <th className="text-uppercase text-center">Rehabilitation Duration</th>
                                        <th className="text-uppercase text-center">Status</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(surgeryHistory) && surgeryHistory.map((surgery, index) => (
                                        <tr key={index}>
                                            <td className="text-center">{index+1}</td>
                                            <td className="text-center">{surgery.surgeryCategoryName}</td>
                                            <td className="text-center">{surgery.bodyRegionName}</td>
                                            <td className="text-center">{formatDate(surgery.dateOfSurgery)}</td>
                                            <td className="text-center">{surgery.procedureSummary}</td>
                                            <td className="text-center">{surgery.complicationsIfAny}</td>
                                            <td className="text-center">{surgery.rehabilitationDurationName}</td>
                                            <td className="text-center">{(surgery.status == 1) ? "Active" : "Inactive"}</td>
                                            <td>
                                                <Link to="#" onClick={() => editDetails(surgery)}>
                                                    <i className="feather-edit" />Edit
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={openModal}
                size="xl"
                centered>
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Surgery Details</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    {/* <form ref={formRef}> */}
                    <div className="row">
                        <div className="col-lg-4">
                            <label className="form-label">Date of Surgery</label>
                            <input
                                type="date"
                                className="form-control"
                                style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                name="dateOfSurgery"
                                value={dos}
                                onChange={(e) => { setDos(e.target.value) }}
                                placeholder="Enter Date of surgery" />
                        </div>
                        <div className="col-lg-4">
                            <label className="form-label">Category</label>
                            <Select
                                value={surgeryCatgList.find(ctg => ctg.surgCatgId === ctgry) ? {
                                    value: ctgry,
                                    label: surgeryCatgList.find(ctg => ctg.surgCatgId === ctgry)?.surgCatgName
                                } : null}
                                onChange={async (e) => {
                                    setCtgry(e.value);
                                }}
                                placeholder="Select Category"
                                options={surgeryCatgList.map(ctg => ({
                                    value: ctg.surgCatgId,
                                    label: ctg.surgCatgName
                                }))}>
                            </Select>
                        </div>
                        <div className="col-lg-4">
                            <label className="form-label">Body Region</label>
                            <Select
                                isMulti
                                value={Array.isArray(bdyRgnList)
                                    ? bdyRgnList
                                        .filter(bdy => bdyRgn.includes(bdy.bdyRgnId))
                                        .map(bdy => ({
                                            value: bdy.bdyRgnId,
                                            label: bdy.bdyRgnName
                                        }))
                                    : []
                                }
                                onChange={(selectedOptions) => {
                                    // const selectedIds = selectedOptions.map(option => option.value);
                                    const selectedIds = Array.isArray(selectedOptions)
                                        ? selectedOptions.map(option => option.value)
                                        : selectedOptions
                                            ? [selectedOptions.value]
                                            : [];
                                    setBdyRgn(selectedIds);
                                }}
                                options={Array.isArray(bdyRgnList)
                                    ? bdyRgnList.map(bdy => ({
                                        value: bdy.bdyRgnId,
                                        label: bdy.bdyRgnName
                                    }))
                                    : []
                                }
                            />
                        </div>
                        <div className="col-lg-4">
                            <label className="form-label">Procedure Summary</label>
                            <input
                                type="text"
                                className="form-control"
                                style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                name="procedureSummary"
                                value={pcdrSumry}
                                onChange={(e) => { setPcdrSumry(e.target.value) }}
                                placeholder="Enter Procedure Summary" />
                        </div>
                        <div className="col-lg-4">
                            <label className="form-label">Complications (if any)</label>
                            <input
                                type="text"
                                className="form-control"
                                style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                name="complicationsIfAny"
                                value={comp}
                                onChange={(e) => { setComp(e.target.value) }}
                                placeholder="Enter Complications" />
                        </div>
                        <div className="col-lg-4">
                            <label className="form-label">Rehabilitation duration</label>
                            <Select
                                value={rehabList.find(rehb => rehb.rehabId === rehab) ? {
                                    value: rehab,
                                    label: rehabList.find(rehb => rehb.rehabId === rehab)?.rehabName
                                } : null}
                                onChange={async (e) => {
                                    setRehab(e.value);
                                }}
                                placeholder="Select Rehabilitation Duration"
                                options={rehabList.map(rehab => ({
                                    value: rehab.rehabId,
                                    label: rehab.rehabName
                                }))}>
                            </Select>
                        </div>
                    </div>
                    <ModalFooter>
                        <Button
                            className="btn-primary text-uppercase"
                            variant="success"
                            type="submit"
                            onClick={handleSubmit}
                        >
                            <b><i className="fas fa-save" />Save</b>
                        </Button>
                    </ModalFooter>
                    {/* </form> */}
                </ModalBody>
            </Modal>
        </>
    );
};

export default SurgeryHistory;